import state from './module-feature-state';
import mutations from './module-feature-mutations';
import actions from './module-feature-actions';
import getters from './module-feature-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
